<script setup lang="ts">
const props = defineProps<{ 
  details: Record<string, any>,
  tagTitle: string,
}>();
const modalsStore = useModalsStore();
const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>

<template>
    <div class="relative z-1">
        <div class="relative w-full">
        <div class="gridClass flex flex-col lg:flex-row justify-between items-center gap-8 lg:gap-0">
            <div class="w-full lg:w-1/2 flex flex-col">
                <div class="w-full">
                    <div class="relative">
                        <IconHighlight class="w-20 absolute right-1/2 translate-x-[50%] lg:right-0 lg:translate-x-0 top-6 lg:top-10" />
                        <h1 class="lg:mt-3 -mb-2 lg:mb-5 text-start relative z-1">
                            <span class="block lg:inline text-center lg:text-start text-[#FEDD5B]">{{ props.details.title.split('؛')[0] }}؛</span>
                            <span class="text-white block lg:inline text-center lg:text-start leading-8">
                                {{ props.details.title.split('؛')[1] }}
                            </span>
                        </h1>
                    </div>
                    <p class="text-white mt-4 lg:mt-2 text-center lg:text-justify w-full lg:w-[95%] text-body1">
                        {{ props.details.desc }}
                    </p>
                    <div class="w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
                        <LandingButton
                            @click="showMainModal"
                            btn-style="!w-[210px] !h-12 !justify-between bg-[#005FEC] text-white"
                            svg-bg-style="bg-white"
                            svg-style="stroke-[#005FEC]"
                            text="دمو و مشاوره رایگان"
                        />
                        <LandingButton
                            @click="scrollToElementById('metama_price', -80)"
                            btn-style="!w-[210px] !h-12 !justify-between bg-white text-[#005FEC]"
                            svg-bg-style="bg-[#005FEC]"
                            svg-style="stroke-white !rotate-0"
                            text="مشاهده تعرفه‌ها"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-[60%] flex justify-center lg:justify-end">
                <MetamaHeroRequestForm />
            </div>
            </div>
        </div>
        <MetamaHeroActiveUsers class="hidden lg:flex mt-3 lg:-mt-5" />
    </div>
</template>